---
meta:
title: Contact
description: Contact of Swiss Esports Hub
links: none
---


import ContentPageLayout from "../components/ContentPageLayout";

# Contact
Hi 👋

We're currently still building this website and are always welcome bug reports or feedback. If you have any questions or bug reports, feel free to fill out following [form](https://github.com/SwisseSportsFederation/esports-hub/issues/new/choose).

export default ({ children }) => <ContentPageLayout>{children}</ContentPageLayout>;
